export const NUM_PARTICIPANTS_S = 0;
export const NUM_PARTICIPANTS_M = 1;
export const NUM_PARTICIPANTS_L = 2;

export const PRICE_PARTICIPANTS_S = 0;
export const PRICE_PARTICIPANTS_M = 50_00;
export const PRICE_PARTICIPANTS_L = 200_00;
